module.exports = __webpack_public_path__ + "static/media/HomePage.04f799a5.png";